const entertainment = [
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Ruchi Kaushal",
        "title": "Parineeti Chopra, Raghav Chadha wedding live: RaagNeeti now married - Hindustan Times",
        "description": "Parineeti Chopra and Raghav Chadha wedding live updates: Several politicians and celebs reached Udaipur to attend the royal wedding of the year.",
        "url": "https://www.hindustantimes.com/entertainment/bollywood/parineeti-chopra-raghav-chadha-wedding-live-updates-udaipur-pictures-videos-guests-101695526408661.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/parineeti_chopra_raghav_chadha_1695465886983_1695567483660.jpg",
        "publishedAt": "2023-09-24T14:06:19Z",
        "content": "Parineeti Chopra and Raghav Chadha wedding live updates: The actor and the AAP leader are getting married on Sunday. After his sehrabandi, Raghav left with his baaraat from The Taj Lake Palace on boa… [+14139 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Entertainment Desk",
        "title": "Ananya Panday, Suhana Khan, Shanaya Kapoor ‘go crazy’ at NMACC art exhibition - Hindustan Times",
        "description": "Childhood friends Ananya Panday, Suhana Khan, and Shanaya Kapoor had a girls' day out at the Nita Mukesh Ambani Cultural Centre in Mumbai. | Bollywood",
        "url": "https://www.hindustantimes.com/entertainment/bollywood/ananya-panday-suhana-khan-shanaya-kapoor-chunky-panday-sanjay-kapoor-nmacc-101695556646243.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/nmacc_1695556937589_1695556955943.jpg",
        "publishedAt": "2023-09-24T12:37:03Z",
        "content": "Childhood friends and actors Ananya Panday, Suhana Khan, and Shanaya Kapoor had a girls' day out at an art exhibition at the Nita Mukesh Ambani Cultural Centre (NMACC) in Mumbai. They were joined by … [+2512 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Entertainment Desk",
        "title": "Soni Razdan pens warm note for Alia, Shaheen, Pooja Bhatt on Daughters Day - Hindustan Times",
        "description": "Soni Razdan is the second wife of Mahesh Bhatt, which makes her Pooja Bhatt's stepmother. Alia Bhatt and Shaheen Bhatt are half-sisters of Pooja and Rahul. | Bollywood",
        "url": "https://www.hindustantimes.com/entertainment/bollywood/soni-razdan-daughters-day-post-for-alia-bhatt-shaheen-bhatt-pooja-bhatt-101695552178192.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/soni_1695553974700_1695553974845.jpg",
        "publishedAt": "2023-09-24T11:25:10Z",
        "content": "Soni Razdan took to her Instagram handle and penned down a note on Daughters Day. Not only did she tag her daughters Alia Bhatt and Shaheen Bhatt but also included her stepchildren, Pooja Bhatt and R… [+2065 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "123telugu.com"
        },
        "author": null,
        "title": "Latest: Dulquer Salmaan’s Lucky Baskhar shoot begins today - 123telugu",
        "description": "Telugu cinema news, Telugu Movies Updates, Latest Movie reviews in Telugu, Telugu cinema reviews, telugu movie reviews, Tollywood, Box office collections, Telugu Movie show times, Theater List, telugu cinema tickets",
        "url": "https://www.123telugu.com/mnews/latest-dulquer-salmaans-lucky-baskhar-shoot-begins-today.html",
        "urlToImage": "https://www.123telugu.com/content/wp-content/themes/123telugu/images/logo.gif",
        "publishedAt": "2023-09-24T10:49:00Z",
        "content": "Mollywood actor Dulquer Salmaan is currently making waves in the Telugu film industry with his upcoming project titled Lucky Baskhar, directed by Venky Atluri. The movie, which garnered attention upo… [+761 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Jagran.com"
        },
        "author": "Simran Srivastav",
        "title": "OTT Releases This Week King Of Kotha, Agent, Choona, Gen V And More Movies And Web Series Streaming Online - Jagran English",
        "description": "If you are looking forward to adding more content to your watchlist take a look at the list of the most-awaited movies and web series releasing this week",
        "url": "https://english.jagran.com/entertainment/ott-releases-this-week-king-of-kotha-agent-choona-gen-v-and-more-movies-and-web-series-streaming-online-10102692",
        "urlToImage": "https://imgeng.jagran.com/images/2023/sep/OTTReleasesThisWeek1695549389081.jpg",
        "publishedAt": "2023-09-24T09:50:00Z",
        "content": "The popularity of watching movies and web series on streaming platforms is on the rise as the audience is able to binge-watch the content of their choice in the comfort of their homes. The OTT platfo… [+3500 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Tapatrisha Das",
        "title": "Karisma Kapoor, in a pink Benarasi saree, takes over the city of Nawabs - Hindustan Times",
        "description": "Karisma looked gorgeous in the pink benarasi saree with intricate embroidery work in gold threads throughout the saree, teamed with a  sleeveless pink blouse.",
        "url": "https://www.hindustantimes.com/photos/lifestyle/karisma-kapoor-in-a-pink-benarasi-saree-takes-over-the-city-of-nawabs-101695542928202.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/k_1695542970174_1695542997615.jpg",
        "publishedAt": "2023-09-24T09:49:36Z",
        "content": null
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "etimes.in",
        "title": "Exclusive: Roadies 19: Sonu Sood puts rest to the tiff between Gang leaders Prince Narula, Rhea Chakrabor - Times of India",
        "description": "Gang leaders Prince Narula, Gautam Gulati and Rhea Chakraborty end up in a massive tiff due to Prince's social media posts. Rhea and Gautam lost their",
        "url": "https://timesofindia.indiatimes.com/tv/news/hindi/exclusive-roadies-19-sonu-sood-puts-rest-to-the-tiff-between-gang-leaders-prince-narula-rhea-chakraborty-and-gautam-gulati-says-social-media-pe-dalne-se-kya-farak-padta-hai/articleshow/103906772.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103906878,width-1070,height-580,imgsize-1121597,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T09:38:00Z",
        "content": "Roadies 19- Vashu betrays gang Rhea to stay loyal to former gang leader Prince NarulaRoadies 19 is keeping fans entertained with its new dynamics after the dissolution of the gangs. Vashu, a loyal me… [+185 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Atlee reveals he got calls from Hollywood after Jawan, turned down blank cheques because he doesn’t work for money - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/entertainment/bollywood/atlee-reveals-he-got-calls-from-hollywood-after-jawan-turned-down-blank-cheques-because-he-doesnt-work-for-money-8953796/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T09:02:42Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Entertainment Desk",
        "title": "Pakistani actor Hania Aamir grooves to Chaleya as Shah Rukh dances behind her - Hindustan Times",
        "description": "This isn't the first time that Hania Aamir danced to a song of Shah Rukh Khan. The Pakistani actor earlier shared a video as she did Shah Rukh's signature pose.",
        "url": "https://www.hindustantimes.com/entertainment/tv/pakistani-actor-hania-aamir-dances-to-jawan-song-chaleya-shah-rukh-khan-101695542844723.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/Hania_Aamir_Jawan_Chaleya_Shah_Rukh_Khan_1695545480975_1695545489504.jpg",
        "publishedAt": "2023-09-24T09:00:51Z",
        "content": "Pakistani actor Hania Aamir is a big fan of Shah Rukh Khan and she has proved it time and again by dancing to his songs and giving his signature pose. Taking to Instagram on Saturday, Hania gave her … [+2061 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "123telugu.com"
        },
        "author": null,
        "title": "OTT: Recent Tamil horror-comedy film streaming now in Telugu - 123telugu",
        "description": "Telugu cinema news, Telugu Movies Updates, Latest Movie reviews in Telugu, Telugu cinema reviews, telugu movie reviews, Tollywood, Box office collections, Telugu Movie show times, Theater List, telugu cinema tickets",
        "url": "https://www.123telugu.com/mnews/ott-recent-tamil-horror-comedy-film-streaming-now-in-telugu.html",
        "urlToImage": "https://www.123telugu.com/content/wp-content/themes/123telugu/images/logo.gif",
        "publishedAt": "2023-09-24T08:30:00Z",
        "content": "The comedian-turned-hero Santhanam starrer DD Returns, which serves as a standalone sequel to Dhilluku Dhuddu 2 and is the third instalment in the Dhilluku Dhuddu franchise, has once again grabbed th… [+503 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Koimoi"
        },
        "author": "Koimoi.com Team",
        "title": "Jawan Box Office (Overseas): Shah Rukh Khan Enters The $40 Million Club Beating Aamir Khan’s Highest Grosser Dangal In North America, Baahubali 2 In Gulf & The Next Target Is RRR! - Koimoi",
        "description": "Shah Rukh Khan's Jawan is still creating records overseas, and the actor achieved another feat. as the film entered the prestigious $40M club",
        "url": "https://www.koimoi.com/box-office/jawan-box-office-overseas-shah-rukh-khan-enters-the-40-million-club-beating-aamir-khans-highest-grosser-dangal-in-north-america-baahubali-2-in-gulf-the-next-target-is-rrr/",
        "urlToImage": "https://static-koimoi.akamaized.net/wp-content/new-galleries/2023/09/jawan-box-office-overseas-shah-rukh-khan-enters-the-40-million-club-beating-aamir-khans-highest-grosser-dangal-in-north-america-baahubali-2-in-gulf-the-next-target-is-rrr.jpg",
        "publishedAt": "2023-09-24T08:00:49Z",
        "content": "Shah Rukh Khan Achieves Another Record In His Book With Jawan Overseas Box Office (Picture Credit: IMDB)\r\nShah Rukh Khan’s Jawan is still working like a charm overseas. The film, which currently stan… [+2223 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Gulte"
        },
        "author": "Shree Ram",
        "title": "Karthi Opens Up On Anna-Vadina Breakup Rumours - Gulte",
        "description": "Kollywood is buzzing with the reports that actor Suriya shifted his base to Mumbai along with his wife Jyothika. Some are even speculating that the family is broken. However, Suriya reported that they shifted to Mumbai only for kids. Meanwhile, Karthi opened …",
        "url": "https://www.gulte.com/movienews/260575/karthi-opens-up-on-anna-vadina-breakup-rumours",
        "urlToImage": "https://cdn.gulte.com/wp-content/uploads/2023/09/karthi.jpg",
        "publishedAt": "2023-09-24T07:39:25Z",
        "content": "Kollywood is buzzing with the reports that actor Suriya shifted his base to Mumbai along with his wife Jyothika. Some are even speculating that the family is broken. However, Suriya reported that the… [+941 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "PINKVILLA"
        },
        "author": "Roopa Radhakrishnan",
        "title": "Kushi OTT release: Here's when and where you can watch Vijay Deverakonda and Samantha Ruth Prabhu starrer - PINKVILLA",
        "description": "The Platform And The Date From Which Vijay Deverakonda And Samantha Ruth Prabhu Starrer Kushi Will Start Streaming On OTT Have Been Made Official, Much To The Utter Delight Of Fans.",
        "url": "https://www.pinkvilla.com/entertainment/south/kushi-ott-release-heres-when-and-where-you-can-watch-vijay-deverakonda-and-samantha-ruth-prabhu-starrer-1245565",
        "urlToImage": "https://www.pinkvilla.com/images/2023-09/2093033040_kushi-title-song-1280-min.jpg",
        "publishedAt": "2023-09-24T07:33:37Z",
        "content": "Kushi, the romantic film featuring Vijay Deverakonda and Samantha Ruth Prabhu, was released earlier this month in theaters. Fans of the films lead protagonists were more than happy with how the Shiva… [+1945 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Arfa Javaid",
        "title": "‘This is amazing’: SRK on viral video of duo dancing to Chaleya in New York - Hindustan Times",
        "description": "Shah Rukh Khan reacted to a dance video featuring the song Chaleya from Jawan. The video was filmed on the Brooklyn Bridge in New York. | Trending",
        "url": "https://www.hindustantimes.com/trending/this-is-amazing-srk-reacts-to-viral-video-of-duo-dancing-to-chaleya-on-brooklyn-bridge-in-new-york-101695538417631.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/SRK-viral-video-dance-chaleya-jawan-new-york_1695539393806_1695539423470.jpg",
        "publishedAt": "2023-09-24T07:11:46Z",
        "content": "Chaleya is Jawans second song, and it was released on August 14. Since then, people have been dancing to this song and sharing numerous choreographies on social media. Among them, a video went viral … [+1665 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "NDTV News"
        },
        "author": null,
        "title": "Dharmendra's Thank You Note For Son Sunny Deol: \"I Really Enjoyed This Trip With You\" - NDTV Movies",
        "description": "he veteran star has shared a video message on Instagram featuring himself and Sunny Deol.",
        "url": "https://www.ndtv.com/entertainment/dharmendra-has-this-to-say-about-his-us-trip-with-son-sunny-deol-4418674",
        "urlToImage": "https://c.ndtvimg.com/2023-09/64adaarg_dharmendra_625x300_24_September_23.jpg",
        "publishedAt": "2023-09-24T06:43:25Z",
        "content": "Dharmendra with Sunny Deol. (courtesy: aapkadharam)\r\nNew Delhi: Sunny Deol and Dharmendra are pure goals. The father-son duo have been treating their fans to glimpses from their US trip. From relishi… [+2229 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "123telugu.com"
        },
        "author": null,
        "title": "Latest update on Gopichand-Sreenu Vaitla movie - 123telugu",
        "description": "Telugu cinema news, Telugu Movies Updates, Latest Movie reviews in Telugu, Telugu cinema reviews, telugu movie reviews, Tollywood, Box office collections, Telugu Movie show times, Theater List, telugu cinema tickets",
        "url": "https://www.123telugu.com/mnews/latest-update-on-gopichand-sreenu-vaitla-movie.html",
        "urlToImage": "https://www.123telugu.com/content/wp-content/themes/123telugu/images/logo.gif",
        "publishedAt": "2023-09-24T06:41:00Z",
        "content": "Macho Star Gopichand and acclaimed director Sreenu Vaitla have teamed up for an eagerly anticipated new movie, tentatively titled Gopichand 32. The film recently had a grand launch event.\r\nTo mark th… [+786 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India Today"
        },
        "author": "Prachi Arya",
        "title": "How dating apps Tinder and Bumble have turned into desi matrimonial sites - India Today",
        "description": "Ever thought you could find your life partner through a dating app? It might sound counter-intuitive, as dating apps aren't thought to lead to committed relationships. But here are some singles who got married through Tinder and Bumble and also the reason why…",
        "url": "https://www.indiatoday.in/sunday-special/story/dating-apps-turning-into-matrimonial-sites-tinder-bumble-getting-gen-z-millennials-married-2439786-2023-09-24",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202309/dating-apps-241853653-16x9.jpeg?VersionId=7phgKwAjhliN9Bd0zt9wP3mtsELQROYn",
        "publishedAt": "2023-09-24T06:22:52Z",
        "content": "It’s a match! And this Tinder match is made in heaven.\r\nMove over Bharatmatrimony, Jeevansathi and Shaadi.com, because dating apps like Tinder, Bumble, Hinge and OkCupid are getting couples married. … [+10198 chars]"
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "The Hindu",
        "title": "Veteran Malayalam filmmaker K.G. George, 77, passes away - The Hindu",
        "description": null,
        "url": "https://www.thehindu.com/entertainment/movies/veteran-film-maker-kg-george-77-passes-away/article67340693.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-24T06:05:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Entertainment Desk",
        "title": "Vikrant Massey, wife Sheetal expecting their first baby; actor shares sweet post - Hindustan Times",
        "description": "Vikrant Massey and Sheetal Thakur tied the knot in February last year. He had shared the first pictures from the wedding along with a note on Instagram. | Bollywood",
        "url": "https://www.hindustantimes.com/entertainment/bollywood/vikrant-massey-wife-sheetal-thakur-expecting-their-first-baby-101695532625518.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/vikrant_massey_1695534551285_1695534566696.jpg",
        "publishedAt": "2023-09-24T05:53:06Z",
        "content": "Actor-couple Vikrant Massey and Sheetal Thakur are expecting their first child. Taking to Instagram on Sunday, Vikrant made the announcement. The news comes over a year after the duo got married. (Al… [+2408 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "etimes.in",
        "title": "Kiku Sharda mourns the demise of his parents, writes 'Lost them both within the last 2 months' - Times of India",
        "description": "Comedian Kiku Sharda shared the heartbreaking news of his parents' demise on Instagram. He expressed his emotions and memories with his mother and des",
        "url": "https://timesofindia.indiatimes.com/tv/news/hindi/kiku-sharda-mourns-the-demise-of-his-parents-writes-lost-them-both-within-the-last-2-months/articleshow/103901431.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103901612,width-1070,height-580,imgsize-1353517,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T05:00:00Z",
        "content": "Rupali Ganguly, Kiku Sharda have fun times with Delnaaz Irani at her lavish birthday bash; see picsActress Delnaaz Irani celebrated her birthday with a lavish party, sharing pictures and videos on In… [+196 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Gadar 2 box office collection day 44: Sunny Deol’s war drama nears end of run, will fall short of Pathaan by Rs 20 crore - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/entertainment/bollywood/gadar-2-box-office-collection-day-44-sunny-deol-film-earns-rs-50-lakh-last-leg-srk-jawan-8953571/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T04:47:01Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "PINKVILLA"
        },
        "author": "Anushka Solanki",
        "title": "Taylor Swift joins Black Lively for dinner date in NYC after being spotted with Sophie Turner and Selena Gomez - PINKVILLA",
        "description": "Taylor Swift Is Currently Off Her Stage Time From The Eras Tour. Amid This, She Takes The Time Off To Meet A Lot Of Her Colleagues From Industry. Here's What We Know About Her Meet With Blake Lively.",
        "url": "https://www.pinkvilla.com/entertainment/hollywood/taylor-swift-joins-black-lively-for-dinner-date-in-nyc-after-being-spotted-with-sophie-turner-and-selena-gomez-1245543",
        "urlToImage": "https://www.pinkvilla.com/images/2023-09/1069505260_taylor-swift-and-blake-lively.jpg",
        "publishedAt": "2023-09-24T04:31:15Z",
        "content": "Taylor Swift has stayed in the news for all the good reasons this year. Be it her immensely successful Eras tour, or be it all the charity that she did during her concerts. For now, the songstress is… [+2227 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Architectural Digest India"
        },
        "author": "Avantika Shankar",
        "title": "This 1,550-square-foot Bengaluru apartment is breezy with a touch of Bali - Architectural Digest India",
        "description": "Dollar Dedhia channels her client’s penchant for travel and art to create a warm and vibrant Bengaluru apartment; a first home for a young family.",
        "url": "https://www.architecturaldigest.in/story/this-1550-square-foot-bengaluru-apartment-is-breezy-with-a-touch-of-bali/",
        "urlToImage": "https://assets.architecturaldigest.in/photos/650d685d1521cc9aaac8e7b8/16:9/w_1280,c_limit/Untitled%20design%20(1).jpg",
        "publishedAt": "2023-09-24T04:30:00Z",
        "content": "Dollar Dedhias recent redesign of a Bengaluru apartment is a case study in elegant interventions that honour the homeowners' personalities. Her clients were a young couple who had relocated to Bengal… [+1944 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "soompi"
        },
        "author": "eclipse01",
        "title": "Song Joong Ki To Host Ahn Hye Kyung's Wedding - soompi",
        "description": "Song Joong Ki To Host Ahn Hye Kyung’s Wedding",
        "url": "https://www.soompi.com/article/1615795wpp/song-joong-ki-to-host-ahn-hye-kyungs-wedding",
        "urlToImage": "https://6.soompi.io/wp-content/uploads/image/20230924042051_Song-Joong-Ki-Ahn-Hye-Kyung.jpg?s=900x600&e=t",
        "publishedAt": "2023-09-24T04:27:59Z",
        "content": "Song Joong Ki has returned to Korea to host the wedding of his longtime friend Ahn Hye Kyung.\r\nOn September 24, actress Ahn Hye Kyung will be tying the knot with her non-celebrity boyfriend at a priv… [+556 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Entertainment Desk",
        "title": "Bigg Boss 17: Salman Khan declares the game won't be same for everyone - Hindustan Times",
        "description": "Bigg Boss 17 will go on air on Colors and JioCinema from October 15 onwards. Salman Khan will return as host once again. Watch the new promo.",
        "url": "https://www.hindustantimes.com/entertainment/tv/bigg-boss-17-salman-khan-declares-the-game-wont-be-same-for-everyone-101695523397414.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/salman_khan_bigg_boss_17_1695525459741_1695525459927.jpg",
        "publishedAt": "2023-09-24T04:07:39Z",
        "content": "Salman Khan is all set to return to the television screens with the new season of reality show Bigg Boss. A new promo was unveiled Saturday evening and shows Salman meddling with a bomb. He even spor… [+1937 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Sounak Mukhopadhyay",
        "title": "‘Jawan’ actor Vijay Sethupathi pulled out of Muttiah Muralitharan’s biopic ‘800’ - here’s why | Mint - Mint",
        "description": "Muttiah Muralitharan's biopic ‘800’ has faced controversy and casting changes, with Madhur Mittal replacing Vijay Sethupathi as the lead.",
        "url": "https://www.livemint.com/news/india/jawan-actor-vijay-sethupathi-pulled-out-of-muttiah-muralitharan-s-biopic-800-here-s-why-11695527492872.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/INDIA-ENTERTAINMENT-CINEMA-BOLLYWOOD-7_1695527646411_1695527659862.jpg",
        "publishedAt": "2023-09-24T04:00:14Z",
        "content": "The producers unveiled the first look of the much-talked-about Muttiah Muralitharan biopic 800 on 17 April 2023, which coincided with the Sri Lankan cricketers birthday. Madhur Mittal is stepping int… [+2682 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India Today"
        },
        "author": "India Today Entertainment Desk",
        "title": "‘The Great Indian Family’ box office collection Day 2: Vicky Kaushal’s film crashes - India Today",
        "description": "The Great Indian Family, featuring Vicky Kaushal, fails to impress audiences, earning merely Rs 1.8 crore on its second day. The film's total box office collection now stands at Rs 3.2 crore after two days.",
        "url": "https://www.indiatoday.in/movies/bollywood/story/the-great-indian-family-box-office-collection-day-2-vicky-kaushals-film-crashes-2439743-2023-09-24",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202309/vicky-kaushal-in-the-great-indian-family-243643631-16x9.jpeg?VersionId=xkbHlfiDx1Bjacg31.LzWgEuefWtKHpm",
        "publishedAt": "2023-09-24T03:35:16Z",
        "content": "Vicky Kaushal returns to the silver screen in 'The Great Indian Family.' The film, which also features Manushi Chhillar, Kumud Mishra, and Manoj Pahwa in key roles, marks Kaushal's next act following… [+1053 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "etimes.in",
        "title": "Vivek Agnihotri claims people are getting paid to not review his film The Vaccine War - IndiaTimes",
        "description": "Vivek claims that today there are thousands of people who are reviewing Shah Rukh Khan's Jawan but no one is talking about his film The Vaccine War. H",
        "url": "https://timesofindia.indiatimes.com/entertainment/hindi/bollywood/news/vivek-agnihotri-claims-people-are-getting-paid-to-not-review-his-film-the-vaccine-war/articleshow/103900011.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103899907,width-1070,height-580,imgsize-19778,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T03:21:00Z",
        "content": "Tanushree Dutta claims Nana Patekar and Vivek Agnihotri need her name for publicityTanushree refuses to speak about Nana Patekar as it would give publicity to his upcoming film with Vivek Agnihotri."
    },
    {
        "source": {
            "id": null,
            "name": "News18"
        },
        "author": "Entertainment Bureau",
        "title": "Katrina Kaif Pregnant, To Welcome Her 1st Baby With Vicky Kaushal? Here's The Truth - News18",
        "description": "Katrina Kaif, who has been married to Vicky Kaushal for nearly two years, has been missing from spotlight for a while, which has led to speculations about her pregnancy.",
        "url": "https://www.news18.com/movies/katrina-kaif-pregnant-to-welcome-her-1st-baby-with-vicky-kaushal-heres-the-truth-8589122.html",
        "urlToImage": "https://images.news18.com/ibnlive/uploads/2023/07/untitled-design-2023-07-29t172633.541-169063179916x9.jpg",
        "publishedAt": "2023-09-24T02:58:44Z",
        "content": "Actor Katrina Kaif has been missing from the media glare for quite some time now. The actress also skipped the Ambani familys Ganesh Chaturthi bash in Mumbai recently, which led to speculations about… [+1787 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Akanksha Agnihotri",
        "title": "Kartik Aaryan and Tara Sutaria twin in stylish pink outfits, leave fans in awe - Hindustan Times",
        "description": "Tara Sutaria and Kartik Aaryan surprise their fans with their stunning and stylish appearance in matching pink attires. Check out their pics and videos inside. | Fashion Trends",
        "url": "https://www.hindustantimes.com/lifestyle/fashion/kartik-aaryan-and-tara-sutaria-twin-in-stylish-pink-outfits-leaving-fans-swooning-watch-their-viral-video-101695494076381.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/photo_2023-09-23_23-33-27_1695521981380_1695521985422.jpg",
        "publishedAt": "2023-09-24T02:23:29Z",
        "content": "Kartik Aaryan and Tara Sutaria recently surprised their fans as the unexpected duo was snapped together in Mumbai on Saturday. Both the stars are equally stunning and we absolutely adore this jodi. T… [+2428 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Telugu360.com"
        },
        "author": "Telugu360",
        "title": "Bigg Boss Telugu 7 Day 20: Nagarjuna’s Interrogation Shakes the House - Telugu360",
        "description": "Bigg Boss Telugu 7 Day 20: Nagarjuna's Interrogation Shakes the House, Shobha shetty third house mate by winning on Priyanka Jain",
        "url": "https://www.telugu360.com/bigg-boss-telugu-7-day-20-nagarjunas-interrogation-shakes-the-house/",
        "urlToImage": "https://www.telugu360.com/wp-content/uploads/2023/09/BB-2.jpg",
        "publishedAt": "2023-09-24T02:04:15Z",
        "content": "The weekend episode of Bigg Boss Telugu Season 7 witnessed some thrilling revelations and intense confrontations as Nagarjuna, the show’s charismatic host, delved deep into the minds and strategies o… [+4187 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India Today"
        },
        "author": "Mita Bhan",
        "title": "Weekly horoscope from September 24 to September 30: Your luck for this week; see which signs have lady luck smiling for them - India Today",
        "description": "What does your luck look like this week September 24  to September 30? Find out in this weekly horoscope for Aries, Taurus, Gemini, Cancer, Leo, Virgo, Libra, Scorpio, Sagittarius, Capricorn, Aquarius and Pisces.",
        "url": "https://www.indiatoday.in/horoscopes/story/weekly-horoscope-september-24-to-september-30-your-luck-for-this-week-which-signs-have-lady-luck-smiling-2439031-2023-09-24",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202309/weekly-horoscope-2023-010938-16x9.jpg?VersionId=9pUsbKprWRVWaMnJ.SRUNTfLvftvMFlu",
        "publishedAt": "2023-09-24T01:10:52Z",
        "content": "Here's what the ancient Tarot cards have to say about your Sun sign for this week:\r\nAries (Mar 21 – Apr 19)\r\nA disaster is averted. The worst is over. And things slowly started looking up. Stay hopef… [+7355 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "PINKVILLA"
        },
        "author": "Akhila Menon",
        "title": "Aamir Khan extends help to families affected by Himachal Pradesh disaster; donates 25 Lakh: Report - PINKVILLA",
        "description": "Aamir Khan, The Bollywood Superstar Has Reportedly Extended Help To The Families Affected By The Himachal Pradesh Natural Disaster. Here's All You Need To Know...",
        "url": "https://www.pinkvilla.com/entertainment/news/aamir-khan-extends-help-to-families-affected-by-himachal-pradesh-disaster-donates-25-lakh-report-1245537",
        "urlToImage": "https://www.pinkvilla.com/images/2023-09/837533621_aamir-khan-himachal-pradesh-1.jpg",
        "publishedAt": "2023-09-24T00:28:58Z",
        "content": "Aamir Khan is currently on a break from films and is rarely seen making public appearances. As per the reports, the Bollywood superstar is currently focussing on his personal life and is busy with th… [+2144 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Gulte"
        },
        "author": "Shree Ram",
        "title": "Bigg Boss 7: Sympathy Grows For Prince Yawar! - Gulte",
        "description": "Bigg Boss 7 is generating a lot of excitement among the audience, especially due to the intense fights in the house. The show is inching the completion of the third week. In the first two weeks, Rathika garnered the screentime, but in the third week, model Pr…",
        "url": "https://www.gulte.com/movienews/260520/bigg-boss-7-sympathy-grows-for-prince-yawar",
        "urlToImage": "https://cdn.gulte.com/wp-content/uploads/2023/09/Prince-Yawar.jpg",
        "publishedAt": "2023-09-23T19:35:15Z",
        "content": "Bigg Boss 7 is generating a lot of excitement among the audience, especially due to the intense fights in the house. The show is inching the completion of the third week. In the first two weeks, Rath… [+1317 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India.com"
        },
        "author": "ANI",
        "title": "Ganesh Chaturthi 2023: Shilpa Shetty, Ankita Lokhande And Others Visit Ektaa Kapoor`s Residence - VIDEO - Zee News",
        "description": "Several TV and film industry celebrities were invited to the residence of TV producer Ektaa Kapoor on the occasion of Ganesh Chaturthi. Among the guests were veteran actor Jeetendra, Shilpa Shetty, Bhushan Kumar, Ridhima Pandit, Sakshi Tanwar, Wardha Nadiadwa…",
        "url": "https://zeenews.india.com/people/ganesh-chaturthi-2023-shilpa-shetty-ankita-lokhande-and-others-visit-ektaa-kapoors-residence-video-2666244.html",
        "urlToImage": "https://english.cdn.zeenews.com/sites/default/files/2023/09/23/1287018-collage-maker-23-sep-2023-09-46-pm-408.jpg",
        "publishedAt": "2023-09-23T16:22:18Z",
        "content": "Mumbai: Several TV and film industry celebrities were invited to the residence of TV producer Ektaa Kapoor on the occasion of Ganesh Chaturthi. Among the guests were veteran actor Jeetendra, Shilpa S… [+3124 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Entertainment Desk",
        "title": "Kareena Kapoor, Saif Ali Khan shocked by magic cards game at her birthday party - Hindustan Times",
        "description": "Kareena recently turned 43. She, Saif Ali Khan, and their kids Taimur and Jeh held her birthday party at the Pataudi Palace. | Bollywood",
        "url": "https://www.hindustantimes.com/entertainment/bollywood/kareena-kapoor-saif-ali-khan-magic-cards-game-birthday-party-watch-101695483264578.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/23/1600x900/saif_kareena_1695483698735_1695483712679.jpg",
        "publishedAt": "2023-09-23T16:10:37Z",
        "content": "Kareena Kapoor seems to have had quite a birthday party at Pataudi Palace on her birthday. In a video now doing the rounds on social media, she's seen with her husband and fellow actor Saif Ali Khan,… [+2099 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "NDTV News"
        },
        "author": null,
        "title": "Vijay Varma On Seeing Kareena Kapoor And Fam On Jaane Jaan Sets: \"I Wanted To Have A Family\" - NDTV Movies",
        "description": "\"The little one was on the set holding a mic and trying to sing,\" said Vijay Varma about Jeh",
        "url": "https://www.ndtv.com/entertainment/vijay-varma-on-seeing-kareena-kapoor-and-fam-on-jaane-jaan-sets-i-wanted-to-have-a-family-4417735",
        "urlToImage": "https://c.ndtvimg.com/2023-09/s8mi40k8_alia-_625x300_23_September_23.jpg",
        "publishedAt": "2023-09-23T15:25:28Z",
        "content": "Image shared on Instagram. (courtesy: kareenakapoorkhan)\r\nNew Delhi: Vijay Varma, who was recently seen sharing screen space with Kareena Kapoor, in a recent interview with The Film Companion, expres… [+1873 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Gulte"
        },
        "author": "Suman M",
        "title": "The Real Twist Of Chandramukhi 2 Revealed? - Gulte",
        "description": "Chandramukhi was a sensational hit back then and it set the trend for modern thrillers. Many movies followed the idea but only a few could enthrall the audience. After many years, the same director came up with the sequel of the movie bringing Lawrence and Ka…",
        "url": "https://www.gulte.com/movienews/260510/the-real-twist-of-chandramukhi-2-revealed",
        "urlToImage": "https://cdn.gulte.com/wp-content/uploads/2023/09/Stills-From-Chandramukhi-2-Trailer.jpg",
        "publishedAt": "2023-09-23T15:09:34Z",
        "content": "Chandramukhi was a sensational hit back then and it set the trend for modern thrillers. Many movies followed the idea but only a few could enthrall the audience. After many years, the same director c… [+1161 chars]"
    }
]


export default entertainment;